module.exports = "<router-outlet #outlet=\"outlet\"></router-outlet>\r\n"